/*
 * @Description: BUS
 * @Author: wangwangwang
 * @Date: 2020-06-22 09:36:27
 * @LastEditors: wangwangwang
 * @LastEditTime: 2020-06-29 11:19:51
 */

import Vue from 'vue'
export default new Vue()
